module.exports = __webpack_public_path__ + "img/calendar2-plus.4f484a30.svg";